<template>
    <header>
      <div class="header-left">
        <div class="menu-logo" >
          <a href="#" class="menu-toggle" v-on:click="menuClick()">
            <i class="icons icon-menu"></i>
          </a>
          <a href="/#/" class="logo"></a>
        </div>
        <div class="alert">
          <div class="icon">
            <i class="icons icon-bell"></i>
          </div>
          <div class="marquee">
            <div id="#overflow" ref="marquee">
              Hello {{displayName}}, {{notice}}
            </div>
          </div>
        </div>
      </div>
      <div class="header-right">
        <a :href="'//outlook.office.com/mail/inbox'" class="header-notify" target="_blank">
          <i class="icons icon-envelope"></i>
          <span class="badge badge-danger"><span>{{mailCount}}</span></span>
        </a>
        <div v-bind:class="{'dropdown':true, 'header-user':true, 'show':toggle}" v-on:click="toggleClick(toggle)">
          <button
            class="dropdown-toggle header-user"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img class="pic" :src="photo"/>
            <div class="title"><span>{{ displayName }}</span></div>
          </button>
          <div v-bind:class="{'dropdown-menu':true, 'dropdown-menu-right':true, 'show':toggle, 'dropdown-bootstrap':true}" v-show="toggle">
            <div class="dropdown-item border-bottom">
              <h5 class="mb-10">Annual Leave This Year</h5>
              <div class="d-flex justify-content-between mb-10">
                <span class="text-grey">Total</span>
                <span>{{totalLeave}} Days</span>
              </div>
              <div class="d-flex justify-content-between">
                <span class="text-grey">Available</span>
                <span>{{availableLeave}} Days</span>
              </div>
              </div>
            <div class="dropdown-item" v-on:click="statistic()">
              <i class="fa fa-plane"></i>Statistic
            </div>
            <div class="dropdown-item" v-on:click="roster()">
              <i class="fa fa-calendar"></i>Roster (Beta)
            </div>
            <div class="dropdown-item" v-on:click="application()">
              <i class="fa fa-clipboard"></i>Application
            </div>
            <div class="dropdown-item" v-on:click="logout()">
              <i class="fa fa-sign-out"></i>Log Out
            </div>
            <div v-if="verifyImpersonateShow" class="dropdown-item" v-on:click="impersonateModalShow()">
              <i class="fa fa-user-secret" aria-hidden="true"></i>Impersonation
            </div>
          </div>
        </div>
      </div>
    </header>
</template>

<script>
export default {
  data: () => ({
    displayName: '',
    notices: [],
    notice: '',
    admins: [],
    mailCount: 0,
    photo: '',
    active: false,
    toggle: false,
    totalLeave: 0,
    availableLeave: 0,
    impersonateModalIsShow: true,
    verifyImpersonateShow: false,
  }),
  async created () {
    if (localStorage.getItem('access_token')) {
    this.displayName = localStorage.getItem('displayName')
    try {
      const resp = await this.getNoticeList(localStorage.getItem('access_token'));
      resp.data.value.forEach((item) => {
        this.notices.push(item.fields);
      });
      this.notices = [...new Set(this.notices)];
      this.notices.sort((a, b) => b.id - a.id);
      this.notice = this.notices[0].Title;
    } catch (err) {
      console.log('err', err);
    } finally {
      // 不管成功失敗（只要不是被登出），都通知外層可以放行了
      this.$store.commit('setTokenReady', true);
    }
    this.marquee();
    this.getAdminList(localStorage.getItem('access_token'))
      .then(resp => {
        resp.data.value.forEach(item => {
          if (item.fields.Role==='Impersonate'){
            this.admins.push(item.fields.Title)   
          }
        })
        this.admins = [...new Set(this.admins)]
        this.verifyImpersonate()
      })
      .catch(err => {
        console.log('err', err)
      })
    this.getUserMail(localStorage.getItem('access_token'))
      .then(resp => {
        this.mailCount = resp.data['@odata.count']
      })
      .catch(err => {
        console.log('err', err)
      })
    this.getUserPhoto(localStorage.getItem('access_token'))
      .then(resp => {
        let reader = new FileReader()
        reader.readAsDataURL(resp.data)
        reader.onload = () => {
          this.photo = reader.result
        }
      })
      .catch(err => {
        console.log('err', err)
      })
    this.getLeaveDetail(localStorage.getItem('mail'))
      .then(resp => {
        var leaveResultArray = resp['data'].data
        let annualResult = leaveResultArray.filter(array => array['leaveCode'] === 'SLC04')
        this.totalLeave = Number(annualResult[0]['accrued']) / 8
        this.availableLeave = Number(annualResult[0]['available']) / 8
      })
      .catch(err => {
        console.log('err', err + localStorage.getItem('mail'))
      })
    } else {
      // 沒登入或離線，也要放行，不然 App.vue 會卡死在 loading
      this.$store.commit('setTokenReady', true);
    }
  },
  mounted(){
    this.marquee();
  },
  methods: {
    isElementOverflow(element){
      const overflowX = element.offsetWidth < element.scrollWidth
      return overflowX
    },
    marquee(){
      const element = this.$refs.marquee;
      if (this.isElementOverflow(element)) {
        element.style.animation= 'marquee 20s infinite linear';
        const keyframesStyle = document.createElement('style');
          keyframesStyle.innerText = '@-webkit-keyframes marquee {0% { -webkit-transform: translateX(100%)}100% { -webkit-transform: translateX(-100%) }}';
        element.appendChild(keyframesStyle)
      }
    },
    sortByKey (array, key, order) {
      return array.sort((a, b) => {
        var x = a[key]
        var y = b[key]
        if (order === 'DESC') {
          return ((x < y) ? 1 : ((x > y) ? -1 : 0))
        } else if (order === 'ASC') {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0))
        }
      })
    },
    menuClick () {
      this.$emit('asideIsClick', this.active)
    },
    toggleClick (toggle) {
      this.toggle = !toggle
    },
    statistic() {
      if (this.$route.path !== '/statistic') {
        this.$router.push('/statistic');
      }
    },
    logout () {
      // this.$store.dispatch('logout').then(() => {
      //   this.$router.push('/login')
      // })
      this.$store.dispatch('logoutout')
    },
    roster() {
      this.$router.push('/roster');
    },
    application(){
      this.$router.push('/application');
    },
    impersonateModalShow () {
      this.$emit('impersonateModal', true)
    },
    verifyImpersonate () {
      if (this.admins.find(ele => ele===localStorage.getItem('mail'))) {
        this.verifyImpersonateShow = true;
        this.$store.dispatch('setImpersonation', true);
      }
      else {
        this.verifyImpersonateShow = false;
        this.$store.dispatch('setImpersonation', false);
      }
    }
  }
  // mounted () {
  //   document.addEventListener('click', (e) => { if (!this.$el.contains(e.target)) this.toggle = false })
  // }
}
</script>

<style lang="scss" scoped>
.marquee{
  overflow: hidden;
}

.dropdown-item {
  cursor: pointer;
}

.header-user {
  background: none;
  border: none;
}
</style>